import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import "./Pagination.css";
import Select from "react-select";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Pagination = ({ currentPage, setCurrentPage, pagesData }) => {
  let token = useSelector((store) => store.userReducer.token);
  let [totalOptions, setTotalOptions] = useState();

  useEffect(() => {
    const myData = [];
    for (let value = 1; value <= pagesData; value++) {
      myData.push({ value: value, label: value });
    }
    setTotalOptions(myData);
  }, [pagesData]);

  const handleChange = (selectedOption) => {
    setCurrentPage(selectedOption.value);
    getComplaintsData(token, selectedOption.value, startDate, endDate);
  };

  console.log("pagesData", pagesData, currentPage);
  return (
    <div className="page-main">
      <div className="page-section">
        {currentPage > 1 && (
          <div onClick={() => setCurrentPage((p) => p - 1)}>
            <FaLessThan />
          </div>
        )}

        <div className="pagination-button">{currentPage}</div>
        {currentPage < pagesData && (
          <div onClick={() => setCurrentPage((p) => p + 1)}>
            <FaGreaterThan />
          </div>
        )}
      </div>
    </div>
  );
};
export default Pagination;
